import BuoyancyImg from '../../Images/BuoyancyImg.jpg'

const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Boyle's Law — Pistons showing P∝1/V ───────────────
function DiagramPistons() {
  const W = 860, H = 320;

  const states = [
    { label:'State 1', P:'P₁ = 1 atm', V:'V₁ = 4L', pistonX: 260, molCount: 6,  col:'#2E75B6', pressure: 1 },
    { label:'State 2', P:'P₂ = 2 atm', V:'V₂ = 2L', pistonX: 180, molCount: 12, col:'#e67e22', pressure: 2 },
    { label:'State 3', P:'P₃ = 4 atm', V:'V₃ = 1L', pistonX: 140, molCount: 16, col:'#c0392b', pressure: 4 },
  ];

  // molecule positions for each state — packed into the cylinder
  function getMolecules(count, maxX, startX, baseY, h) {
    const mols = [];
    const seed = [0.15,0.45,0.75,0.25,0.55,0.85,0.10,0.40,0.70,0.30,0.60,0.90,0.20,0.50,0.80,0.35];
    const seedY = [0.2,0.6,0.3,0.8,0.5,0.15,0.7,0.4,0.9,0.25,0.65,0.45,0.55,0.35,0.75,0.60];
    for (let i = 0; i < Math.min(count, seed.length); i++) {
      mols.push({
        x: startX + 10 + seed[i] * (maxX - startX - 20),
        y: baseY + 10 + seedY[i] * (h - 20),
      });
    }
    return mols;
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Boyle's Law — Compressing a Gas at Constant Temperature</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="pArr" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#c0392b" />
          </marker>
          <marker id="pArrB" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#2E75B6" />
          </marker>
        </defs>

        {states.map((st, si) => {
          const baseX = 40 + si * 270;
          const cylLeft = baseX + 30;
          const cylRight = baseX + 300;
          const cylTop = 80;
          const cylBot = 220;
          const cylH = cylBot - cylTop;
          const gasRight = cylLeft + st.pistonX;
          const mols = getMolecules(st.molCount, gasRight, cylLeft, cylTop, cylH);

          return (
            <g key={si}>
              {/* Cylinder walls */}
              <rect x={cylLeft} y={cylTop} width={cylRight - cylLeft} height={cylH}
                rx={4} fill="#f5f5f5" stroke="#555" strokeWidth="2" />

              {/* Gas region */}
              <rect x={cylLeft + 2} y={cylTop + 2} width={gasRight - cylLeft - 4} height={cylH - 4}
                rx={2} fill={st.col} opacity="0.08" />

              {/* Piston */}
              <rect x={gasRight} y={cylTop + 2} width={22} height={cylH - 4}
                rx={3} fill="#888" stroke="#444" strokeWidth="1.5" />
              {/* piston hatching */}
              {[0,1,2,3,4,5].map(i => (
                <line key={i} x1={gasRight + 3} y1={cylTop + 12 + i * 22}
                  x2={gasRight + 19} y2={cylTop + 4 + i * 22}
                  stroke="#666" strokeWidth="1" />
              ))}

              {/* Pressure arrows pushing from right (more arrows = more pressure) */}
              {Array.from({ length: st.pressure }).map((_, ai) => {
                const ay = cylTop + 30 + ai * (cylH / (st.pressure + 1));
                return (
                  <line key={ai}
                    x1={gasRight + 50 + ai * 4} y1={ay}
                    x2={gasRight + 28} y2={ay}
                    stroke="#c0392b" strokeWidth="2" markerEnd="url(#pArr)" />
                );
              })}

              {/* Molecules */}
              {mols.map((m, mi) => (
                <g key={mi}>
                  <circle cx={m.x} cy={m.y} r={6} fill={st.col} opacity="0.7" />
                  {/* velocity lines */}
                  <line x1={m.x} y1={m.y} x2={m.x + 8} y2={m.y - 5} stroke={st.col} strokeWidth="1" opacity="0.5" />
                </g>
              ))}

              {/* Labels */}
              <text x={cylLeft + (gasRight - cylLeft) / 2} y={cylTop - 18}
                textAnchor="middle" fontSize="12" fontWeight="700" fill={st.col}>{st.label}</text>
              <text x={cylLeft + (gasRight - cylLeft) / 2} y={cylTop - 5}
                textAnchor="middle" fontSize="10" fill="#333">{st.P}</text>

              {/* Volume bracket */}
              <line x1={cylLeft} y1={cylBot + 18} x2={gasRight} y2={cylBot + 18} stroke="#2E75B6" strokeWidth="1.5" />
              <line x1={cylLeft} y1={cylBot + 12} x2={cylLeft} y2={cylBot + 24} stroke="#2E75B6" strokeWidth="1.5" />
              <line x1={gasRight} y1={cylBot + 12} x2={gasRight} y2={cylBot + 24} stroke="#2E75B6" strokeWidth="1.5" />
              <text x={cylLeft + (gasRight - cylLeft) / 2} y={cylBot + 34}
                textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">{st.V}</text>

              {/* P×V constant */}
              <rect x={cylLeft} y={cylBot + 44} width={gasRight - cylLeft} height={22} rx={3}
                fill={st.col} opacity="0.12" stroke={st.col} strokeWidth="1" />
              <text x={cylLeft + (gasRight - cylLeft) / 2} y={cylBot + 59}
                textAnchor="middle" fontSize="10" fill={st.col} fontWeight="700" fontFamily="'Courier New',monospace">
                P×V = const
              </text>
            </g>
          );
        })}

        {/* Temperature label */}
        <text x={430} y={22} textAnchor="middle" fontSize="11" fill="#555" fontStyle="italic">
          Isothermal process — temperature T held constant throughout
        </text>

        {/* Equal signs between states */}
        <text x={340} y={200} textAnchor="middle" fontSize="22" fill="#555" fontWeight="700">=</text>
        <text x={610} y={200} textAnchor="middle" fontSize="22" fill="#555" fontWeight="700">=</text>
      </svg>
      <div style={S.dCaption}>
        As the piston compresses the gas, the molecules are forced into a smaller volume. They collide with the walls more frequently, increasing the pressure. The product P × V remains constant throughout, demonstrating Boyle's Law.
      </div>
    </div>
  );
}

// ── Diagram 2: P-V Graph — Hyperbola and Isotherms ────────────────
function DiagramPVGraph() {
  const W = 860, H = 360;

  // Isotherms: PV = nRT = k for different T
  const temps = [
    { k: 200, label: 'T₁ (lowest)', col: '#2E75B6' },
    { k: 350, label: 'T₂',          col: '#27ae60' },
    { k: 550, label: 'T₃',          col: '#e67e22' },
    { k: 800, label: 'T₄ (highest)',col: '#c0392b' },
  ];

  const axisLeft = 80, axisBot = 300, plotW = 680, plotH = 260;

  function hyperbola(k) {
    const pts = [];
    for (let v = 30; v <= 700; v += 8) {
      const p = k / v;
      if (p > 250) continue;
      const x = axisLeft + (v / 700) * plotW;
      const y = axisBot - (p / 250) * plotH;
      if (y < axisBot - plotH + 5) continue;
      pts.push(`${x},${y}`);
    }
    return pts;
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>P–V Diagram — Boyle's Law Isotherms (Hyperbolas at Different Temperatures)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="axArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* Axes */}
        <line x1={axisLeft} y1={axisBot - plotH - 10} x2={axisLeft} y2={axisBot} stroke="#555" strokeWidth="1.8" markerEnd="url(#axArr)" />
        <line x1={axisLeft} y1={axisBot} x2={axisLeft + plotW + 20} y2={axisBot} stroke="#555" strokeWidth="1.8" markerEnd="url(#axArr)" />
        <text x={axisLeft - 6} y={axisBot - plotH - 12} textAnchor="end" fontSize="12" fill="#555">P</text>
        <text x={axisLeft + plotW + 22} y={axisBot + 4} fontSize="12" fill="#555">V</text>

        {/* Gridlines */}
        {[50,100,150,200,250].map(p => {
          const y = axisBot - (p / 250) * plotH;
          return (
            <g key={p}>
              <line x1={axisLeft - 5} y1={y} x2={axisLeft + plotW} y2={y} stroke="#eee" strokeWidth="1" />
              <text x={axisLeft - 8} y={y + 4} textAnchor="end" fontSize="9" fill="#aaa">{p}</text>
            </g>
          );
        })}
        {[100,200,300,400,500,600,700].map(v => {
          const x = axisLeft + (v / 700) * plotW;
          return (
            <g key={v}>
              <line x1={x} y1={axisBot + 5} x2={x} y2={axisBot - plotH} stroke="#eee" strokeWidth="1" />
              <text x={x} y={axisBot + 16} textAnchor="middle" fontSize="9" fill="#aaa">{v}</text>
            </g>
          );
        })}
        <text x={axisLeft - 30} y={axisBot - plotH / 2} fontSize="10" fill="#555" textAnchor="middle" transform={`rotate(-90,${axisLeft - 30},${axisBot - plotH / 2})`}>Pressure (kPa)</text>
        <text x={axisLeft + plotW / 2} y={axisBot + 30} fontSize="10" fill="#555" textAnchor="middle">Volume (cm³)</text>

        {/* Isotherms */}
        {temps.map(({ k, label, col }) => {
          const pts = hyperbola(k);
          // end point for label
          const lastPt = pts[pts.length - 1].split(',');
          return (
            <g key={k}>
              <path d={'M ' + pts.join(' L ')} fill="none" stroke={col} strokeWidth="2.2" />
              <text x={parseFloat(lastPt[0]) + 8} y={parseFloat(lastPt[1]) + 4}
                fontSize="10" fill={col} fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* PV = const annotation boxes */}
        <rect x={580} y={20} width={260} height={100} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.2" />
        <text x={710} y={40} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7B0D0D">Key Relationships</text>
        <text x={592} y={58} fontSize="10" fontFamily="'Courier New',monospace" fill="#1a1a2e">PV = k  (at const T)</text>
        <text x={592} y={74} fontSize="10" fontFamily="'Courier New',monospace" fill="#1a1a2e">P₁V₁ = P₂V₂</text>
        <text x={592} y={90} fontSize="10" fill="#555">Each curve: P × V = nRT</text>
        <text x={592} y={106} fontSize="10" fill="#555">Higher T → higher curve</text>

        {/* Arrows showing constant P×V along a curve */}
        <text x={250} y={340} textAnchor="middle" fontSize="10" fill="#27ae60" fontStyle="italic">
          Moving along any curve: P increases as V decreases (and vice versa)
        </text>
      </svg>
      <div style={S.dCaption}>
        Each curve (isotherm) is a rectangular hyperbola PV = constant. At higher temperatures the constant is larger (nRT is larger), so the hyperbola sits higher. Any point on a given curve obeys P₁V₁ = P₂V₂.
      </div>
    </div>
  );
}

// ── Diagram 3: Molecular Kinetic Theory explanation ───────────────
function DiagramKineticTheory() {
  const W = 860, H = 310;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Kinetic Theory — Why Pressure Increases When Volume Decreases</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="vArr" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#2E75B6" />
          </marker>
          <marker id="vArrR" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#c0392b" />
          </marker>
        </defs>

        {/* Large volume box — low pressure */}
        <rect x={20} y={30} width={370} height={260} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2} " />
        <text x={205} y={55} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Large Volume — Low Pressure</text>

        {/* Molecules with long free paths */}
        {[
          [80,120],[180,90],[290,140],[120,200],[240,180],[340,100],[70,240],[200,250],[310,230],
        ].map(([x,y], i) => (
          <g key={i}>
            <circle cx={x} cy={y} r={9} fill="#2E75B6" opacity="0.7" />
            {/* random velocity vectors */}
            {[[-18,-8],[15,-12],[-10,14],[12,10],[-14,4],[8,-16],[16,6],[-8,-14],[10,12]][i] && (
              <line x1={x} y1={y}
                x2={x + [-18,-8,15,-12,-10,14,12,10,-14][i % 9]}
                y2={y + [-8,15,-12,-10,14,12,10,-14,4][i % 9]}
                stroke="#2E75B6" strokeWidth="1.5" markerEnd="url(#vArr)" />
            )}
          </g>
        ))}

        {/* Collision indicator - few */}
        <text x={205} y={285} textAnchor="middle" fontSize="10" fill="#2E75B6">Few wall collisions per second → Low P</text>

        {/* Arrow between boxes */}
        <line x1={400} y1={160} x2={445} y2={160} stroke="#555" strokeWidth="2.5" />
        <polygon points="440,154 452,160 440,166" fill="#555" />
        <text x={425} y={150} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">Compress</text>
        <text x={425} y={164} textAnchor="middle" fontSize="9" fill="#555">V halved</text>
        <text x={425} y={176} textAnchor="middle" fontSize="9" fill="#555">T constant</text>

        {/* Small volume box — high pressure */}
        <rect x={455} y={65} width={250} height={190} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="2" />
        <text x={580} y={55} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Small Volume — High Pressure</text>

        {/* Same molecules but packed tighter */}
        {[
          [490,110],[540,90],[600,120],[660,100],[700,80],[480,160],[550,170],[630,155],[690,170],
        ].map(([x,y], i) => (
          <g key={i}>
            <circle cx={x} cy={y} r={9} fill="#c0392b" opacity="0.7" />
            {/* shorter paths — bounce arrows */}
            {(x < 495 || x > 695 || y < 82 || y > 238) && (
              <line x1={x} y1={y}
                x2={x + [-12,-8,10,-10,8,-14,12,-8,10][i % 9]}
                y2={y + [-8,10,-10,8,-14,12,-8,10,-12][i % 9]}
                stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#vArrR)" />
            )}
          </g>
        ))}

        {/* Wall collision markers */}
        {[85,110,135,160,185,210,230].map((y, i) => (
          <text key={i} x={460} y={y} fontSize="10" fill="#c0392b" fontWeight="700">✕</text>
        ))}
        {[85,115,145,175,205,230].map((y, i) => (
          <text key={i} x={693} y={y} fontSize="10" fill="#c0392b" fontWeight="700">✕</text>
        ))}
        <text x={580} y={273} textAnchor="middle" fontSize="10" fill="#c0392b">Many wall collisions per second → High P</text>

        {/* Key insight box */}
        <rect x={455} y={270} width={390} height={35} rx={4} fill="#fff" stroke="#c0392b" strokeWidth="1.2} " />
        <text x={650} y={291} textAnchor="middle" fontSize="10" fontWeight="700" fill="#1a1a2e" fontFamily="'Courier New',monospace">
          Same kinetic energy (same T) → P ∝ collision frequency ∝ 1/V
        </text>
      </svg>
      <div style={S.dCaption}>
        At constant temperature, molecules have the same average kinetic energy. In a smaller volume they travel shorter distances between collisions with walls, so they strike the walls more frequently. More collisions per second means higher pressure — exactly the P ∝ 1/V relationship of Boyle's Law.
      </div>
    </div>
  );
}

// ── Diagram 4: Combined Gas Law — three variables ─────────────────
function DiagramCombinedGasLaw() {
  const W = 860, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Gas Laws — Boyle's, Charles's and Gay-Lussac's as Special Cases of the Ideal Gas Law</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Central Ideal Gas Law box */}
        <rect x={300} y={110} width={260} height={100} rx={8} fill="#fff" stroke="#7B0D0D" strokeWidth="2.5" />
        <text x={430} y={137} textAnchor="middle" fontSize="13" fontWeight="700" fill="#7B0D0D">Ideal Gas Law</text>
        <text x={430} y={162} textAnchor="middle" fontSize="18" fontWeight="700" fill="#1a1a2e" fontFamily="'Courier New',monospace">PV = nRT</text>
        <text x={430} y={182} textAnchor="middle" fontSize="10" fill="#555">n = moles, R = 8.314 J mol⁻¹ K⁻¹</text>
        <text x={430} y={196} textAnchor="middle" fontSize="10" fill="#555">T must be in Kelvin</text>

        {/* Boyle's Law */}
        <rect x={20} y={20} width={220} height={90} rx={6} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="2} " />
        <text x={130} y={42} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Boyle's Law</text>
        <text x={130} y={60} textAnchor="middle" fontSize="11" fontFamily="'Courier New',monospace" fill="#1a1a2e">P₁V₁ = P₂V₂</text>
        <text x={130} y={76} textAnchor="middle" fontSize="10" fill="#555">T and n constant</text>
        <text x={130} y={90} textAnchor="middle" fontSize="10" fill="#2E75B6">P ∝ 1/V</text>
        {/* Connecting line */}
        <line x1={240} y1={65} x2={298} y2={140} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="6,3" />

        {/* Charles's Law */}
        <rect x={620} y={20} width={220} height={90} rx={6} fill="#f0fff4" stroke="#27ae60" strokeWidth="2" />
        <text x={730} y={42} textAnchor="middle" fontSize="12" fontWeight="700" fill="#27ae60">Charles's Law</text>
        <text x={730} y={60} textAnchor="middle" fontSize="11" fontFamily="'Courier New',monospace" fill="#1a1a2e">V₁/T₁ = V₂/T₂</text>
        <text x={730} y={76} textAnchor="middle" fontSize="10" fill="#555">P and n constant</text>
        <text x={730} y={90} textAnchor="middle" fontSize="10" fill="#27ae60">V ∝ T</text>
        <line x1={620} y1={65} x2={562} y2={140} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="6,3" />

        {/* Gay-Lussac's Law */}
        <rect x={20} y={210} width={220} height={90} rx={6} fill="#fff5e6" stroke="#e67e22" strokeWidth="2" />
        <text x={130} y={232} textAnchor="middle" fontSize="12" fontWeight="700" fill="#e67e22">Gay-Lussac's Law</text>
        <text x={130} y={250} textAnchor="middle" fontSize="11" fontFamily="'Courier New',monospace" fill="#1a1a2e">P₁/T₁ = P₂/T₂</text>
        <text x={130} y={266} textAnchor="middle" fontSize="10" fill="#555">V and n constant</text>
        <text x={130} y={280} textAnchor="middle" fontSize="10" fill="#e67e22">P ∝ T</text>
        <line x1={240} y1={255} x2={298} y2={205} stroke="#e67e22" strokeWidth="1.5" strokeDasharray="6,3" />

        {/* Combined Gas Law */}
        <rect x={620} y={210} width={220} height={90} rx={6} fill="#fff5f5" stroke="#c0392b" strokeWidth="2" />
        <text x={730} y={232} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Combined Gas Law</text>
        <text x={730} y={252} textAnchor="middle" fontSize="11" fontFamily="'Courier New',monospace" fill="#1a1a2e">P₁V₁/T₁ = P₂V₂/T₂</text>
        <text x={730} y={268} textAnchor="middle" fontSize="10" fill="#555">n constant</text>
        <text x={730} y={282} textAnchor="middle" fontSize="10" fill="#c0392b">All three vary</text>
        <line x1={620} y1={255} x2={562} y2={210} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="6,3" />

        {/* Lock labels on connecting lines */}
        <text x={248} y={108} fontSize="9" fill="#2E75B6" fontStyle="italic">T fixed</text>
        <text x={585} y={108} fontSize="9" fill="#27ae60" fontStyle="italic">P fixed</text>
        <text x={248} y={230} fontSize="9" fill="#e67e22" fontStyle="italic">V fixed</text>
        <text x={575} y={230} fontSize="9" fill="#c0392b" fontStyle="italic">n fixed</text>
      </svg>
      <div style={S.dCaption}>
        All three classical gas laws are special cases of the Ideal Gas Law PV = nRT, obtained by holding one variable constant. The Combined Gas Law allows any two of the three variables to change simultaneously while keeping n fixed.
      </div>
    </div>
  );
}

// ── Diagram 5: Real vs Ideal Gas ──────────────────────────────────
function DiagramRealVsIdeal() {
  const W = 860, H = 340;

  // Ideal: PV = 1 for all P (Z=1)
  // Real gas: Z varies — van der Waals
  // Approximate Z curves for different gases
  function zCurve(P, gas) {
    if (gas === 'ideal') return 1.0;
    if (gas === 'H2')    return 1 + 0.00065 * P;                            // always above 1
    if (gas === 'N2')    return 1 - 0.0005 * P + 0.0000012 * P * P;        // dips then rises
    if (gas === 'CO2')   return 1 - 0.0025 * P + 0.0000025 * P * P;        // dips more
    return 1;
  }

  const gases = [
    { key:'ideal', col:'#555', dash:'8,4', label:'Ideal gas (Z = 1)' },
    { key:'H2',    col:'#2E75B6', dash:'none', label:'H₂' },
    { key:'N2',    col:'#27ae60', dash:'none', label:'N₂' },
    { key:'CO2',   col:'#c0392b', dash:'none', label:'CO₂' },
  ];

  const axL = 80, axB = 280, pW = 700, pH = 240;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Real vs Ideal Gas — Compressibility Factor Z = PV/nRT</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="axAr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* Axes */}
        <line x1={axL} y1={axB - pH - 10} x2={axL} y2={axB} stroke="#555" strokeWidth="1.8" markerEnd="url(#axAr)" />
        <line x1={axL} y1={axB} x2={axL + pW + 20} y2={axB} stroke="#555" strokeWidth="1.8" markerEnd="url(#axAr)" />
        <text x={axL - 6} y={axB - pH - 12} textAnchor="end" fontSize="11" fill="#555">Z</text>
        <text x={axL + pW + 22} y={axB + 4} fontSize="11" fill="#555">P (atm)</text>

        {/* Z = 1 reference already on ideal line */}
        {/* Gridlines */}
        {[0.6, 0.8, 1.0, 1.2, 1.4].map(z => {
          const y = axB - ((z - 0.4) / 1.2) * pH;
          return (
            <g key={z}>
              <line x1={axL - 5} y1={y} x2={axL + pW} y2={y} stroke="#eee" strokeWidth="1" />
              <text x={axL - 8} y={y + 4} textAnchor="end" fontSize="9" fill="#aaa">{z.toFixed(1)}</text>
            </g>
          );
        })}
        {[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000].map(p => {
          const x = axL + (p / 1000) * pW;
          return (
            <g key={p}>
              <line x1={x} y1={axB + 4} x2={x} y2={axB - pH} stroke="#eee" strokeWidth="1" />
              <text x={x} y={axB + 16} textAnchor="middle" fontSize="9" fill="#aaa">{p}</text>
            </g>
          );
        })}

        {/* Curves */}
        {gases.map(({ key, col, dash, label }) => {
          const pts = [];
          for (let p = 0; p <= 1000; p += 10) {
            const z = zCurve(p, key);
            const x = axL + (p / 1000) * pW;
            const y = axB - ((z - 0.4) / 1.2) * pH;
            if (y < axB - pH + 2 || y > axB - 2) continue;
            pts.push(`${x},${y}`);
          }
          const lastPt = pts[pts.length - 1].split(',');
          return (
            <g key={key}>
              <path d={'M ' + pts.join(' L ')} fill="none" stroke={col} strokeWidth="2.2"
                strokeDasharray={dash === 'none' ? undefined : dash} />
              <text x={parseFloat(lastPt[0]) + 8} y={parseFloat(lastPt[1]) + 4}
                fontSize="10" fill={col} fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Annotations */}
        <text x={200} y={50} fontSize="10" fill="#c0392b">Attractive forces dominate</text>
        <text x={200} y={62} fontSize="10" fill="#c0392b">(Z &lt; 1, easier to compress)</text>
        <text x={480} y={55} fontSize="10" fill="#2E75B6">Repulsive forces dominate</text>
        <text x={480} y={67} fontSize="10" fill="#2E75B6">(Z &gt; 1, harder to compress)</text>

        {/* Van der Waals label */}
        <rect x={20} y={290} width={820} height={38} rx={4} fill="#fff" stroke="#7B0D0D" strokeWidth="1.2} " />
        <text x={430} y={308} textAnchor="middle" fontSize="10" fontWeight="700" fill="#1a1a2e" fontFamily="'Courier New',monospace">
          Van der Waals equation:  (P + an²/V²)(V − nb) = nRT
        </text>
        <text x={430} y={322} textAnchor="middle" fontSize="10" fill="#555">
          a = intermolecular attraction constant;  b = molecular volume correction
        </text>
      </svg>
      <div style={S.dCaption}>
        The compressibility factor Z = PV/nRT equals 1 for an ideal gas. Real gases deviate: at moderate pressures intermolecular attractions reduce Z below 1; at high pressures molecular volume makes Z exceed 1. CO₂ deviates most strongly; H₂ always exceeds 1.
      </div>
    </div>
  );
}

// ── Diagram 6: Fluid Pressure and Pascal's Law ────────────────────
function DiagramPascal() {
  const W = 860, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pascal's Law — Pressure Transmission in an Enclosed Fluid (Hydraulic System)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="fArr" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#c0392b" />
          </marker>
          <marker id="fArrB" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#2E75B6" />
          </marker>
        </defs>

        {/* Fluid (blue) connecting two cylinders */}
        <path d="M 120,180 L 120,250 L 740,250 L 740,180" fill="none" stroke="#2E75B6" strokeWidth="2.5" />
        {/* Bottom horizontal fluid fill */}
        <rect x={120} y={250} width={620} height={30} fill="#2E75B6" opacity="0.25" />
        {/* Vertical left cylinder */}
        <rect x={90} y={80} width={60} height={200} rx={4} fill="#d6eaf8" stroke="#2E75B6" strokeWidth="2" />
        <rect x={90} y={185} width={60} height={95} fill="#2E75B6" opacity="0.3" />
        {/* Vertical right cylinder (larger) */}
        <rect x={700} y={80} width={120} height={200} rx={4} fill="#d6eaf8" stroke="#2E75B6" strokeWidth="2" />
        <rect x={700} y={185} width={120} height={95} fill="#2E75B6" opacity="0.3" />

        {/* Left piston */}
        <rect x={92} y={150} width={56} height={18} rx={3} fill="#888" stroke="#444" strokeWidth="1.5" />
        {/* Right piston */}
        <rect x={702} y={150} width={116} height={18} rx={3} fill="#888" stroke="#444" strokeWidth="1.5" />

        {/* Force arrows left (small) */}
        <line x1={120} y1={90} x2={120} y2={148} stroke="#c0392b" strokeWidth="3" markerEnd="url(#fArr)" />
        <text x={120} y={82} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">F₁</text>
        <text x={120} y={70} textAnchor="middle" fontSize="10" fill="#c0392b">(small)</text>

        {/* Force arrow right (large — upward) */}
        <line x1={760} y1={148} x2={760} y2={90} stroke="#2E75B6" strokeWidth="5" markerEnd="url(#fArrB)" />
        <text x={760} y={82} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">F₂</text>
        <text x={760} y={70} textAnchor="middle" fontSize="10" fill="#2E75B6">(large)</text>

        {/* Area labels */}
        <text x={120} y={280} textAnchor="middle" fontSize="10" fill="#555">A₁ (small area)</text>
        <text x={760} y={280} textAnchor="middle" fontSize="10" fill="#555">A₂ (large area)</text>

        {/* Pascal's law formula */}
        <rect x={250} y={50} width={360} height={90} rx={6} fill="#fff" stroke="#c0392b" strokeWidth="1.5} " />
        <text x={430} y={72} textAnchor="middle" fontSize="12" fontWeight="700" fill="#7B0D0D">Pascal's Law</text>
        <text x={430} y={92} textAnchor="middle" fontSize="13" fontFamily="'Courier New',monospace" fill="#1a1a2e">P = F₁/A₁ = F₂/A₂</text>
        <text x={430} y={110} textAnchor="middle" fontSize="10" fill="#555">Pressure applied to enclosed fluid</text>
        <text x={430} y={124} textAnchor="middle" fontSize="10" fill="#555">transmits equally in all directions</text>

        {/* Pressure dot arrows radiating in fluid */}
        {[[200,240],[300,240],[400,240],[500,240],[600,240],[300,260],[500,260]].map(([x,y],i)=>(
          <g key={i}>
            <circle cx={x} cy={y} r={3} fill="#2E75B6" opacity="0.5" />
            {[0,45,90,135,180,225,270,315].map((deg,j)=>{
              const r=10, rad=deg*Math.PI/180;
              return <line key={j} x1={x} y1={y} x2={x+r*Math.cos(rad)} y2={y+r*Math.sin(rad)}
                stroke="#2E75B6" strokeWidth="0.8" opacity="0.4" />;
            })}
          </g>
        ))}

        {/* Mechanical advantage */}
        <text x={430} y={310} textAnchor="middle" fontSize="10" fill="#555" fontStyle="italic">
          Mechanical advantage: F₂ = F₁ × (A₂/A₁) — hydraulic jack, car brake, hydraulic press
        </text>
      </svg>
      <div style={S.dCaption}>
        Pascal's Law: pressure applied to an enclosed fluid transmits undiminished throughout. A small force on a small piston generates the same pressure as a large force on a large piston, enabling the hydraulic mechanical advantage F₂/F₁ = A₂/A₁.
      </div>
    </div>
  );
}

// ── Diagram 7: Fluid Pressure with Depth ─────────────────────────
function DiagramHydrostaticPressure() {
  const W = 860, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Hydrostatic Pressure — Pressure Increases with Depth in a Fluid</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="dArr" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#2E75B6" />
          </marker>
          <marker id="dArrG" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#27ae60" />
          </marker>
          <linearGradient id="waterGrad" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%"   stopColor="#2E75B6" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#2E75B6" stopOpacity="0.55" />
          </linearGradient>
        </defs>

        {/* Tank */}
        <rect x={60} y={40} width={340} height={260} rx={6} fill="url(#waterGrad)" stroke="#2E75B6" strokeWidth="2.5" />

        {/* Surface */}
        <line x1={60} y1={40} x2={400} y2={40} stroke="#2E75B6" strokeWidth="2" />
        <text x={230} y={32} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">P₀ (atmospheric)</text>

        {/* Depth markers and horizontal pressure lines */}
        {[
          { h:60,  label:'h₁',  P:'P₀ + ρgh₁',  arrowW:30, col:'#27ae60' },
          { h:130, label:'h₂',  P:'P₀ + ρgh₂',  arrowW:65, col:'#e67e22' },
          { h:200, label:'h₃',  P:'P₀ + ρgh₃',  arrowW:110, col:'#c0392b' },
        ].map((d, i) => {
          const y = 40 + d.h;
          return (
            <g key={i}>
              {/* Horizontal pressure indicator */}
              <line x1={60} y1={y} x2={400} y2={y} stroke={d.col} strokeWidth="1" strokeDasharray="5,3" opacity="0.5" />
              {/* Depth label */}
              <line x1={420} y1={40} x2={420} y2={y} stroke={d.col} strokeWidth="1.5" strokeDasharray="4,3" />
              <text x={428} y={y + 4} fontSize="10" fill={d.col} fontWeight="700">{d.label}</text>
              {/* Pressure arrow outward from wall */}
              <line x1={60} y1={y} x2={60 - d.arrowW} y2={y} stroke={d.col} strokeWidth="2.5" markerEnd="url(#dArr)" />
              <text x={60 - d.arrowW - 5} y={y + 4} textAnchor="end" fontSize="9" fill={d.col}>{d.P}</text>
            </g>
          );
        })}

        {/* Gravity arrow */}
        <line x1={230} y1={55} x2={230} y2={130} stroke="#555" strokeWidth="2" markerEnd="url(#dArr)" />
        <text x={240} y={90} fontSize="10" fill="#555" fontWeight="700">g</text>

        {/* Right panel: P vs depth graph */}
        <rect x={480} y={30} width={360} height={275} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={660} y={52} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Pressure vs Depth Graph</text>

        {/* Axes */}
        <line x1={530} y1={65} x2={530} y2={285} stroke="#555" strokeWidth="1.5" markerEnd="url(#dArr)" />
        <line x1={520} y1={275} x2={820} y2={275} stroke="#555" strokeWidth="1.5" markerEnd="url(#dArr)" />
        <text x={524} y={62} fontSize="9" textAnchor="end" fill="#555">h</text>
        <text x={822} y={280} fontSize="9" fill="#555">P</text>

        {/* Linear P vs h line */}
        <line x1={530} y1={275} x2={810} y2={75} stroke="#c0392b" strokeWidth="2.5" />

        {/* Slope annotation */}
        <line x1={600} y1={275} x2={600} y2={225} stroke="#27ae60" strokeWidth="1.2" strokeDasharray="4,3" />
        <line x1={600} y1={225} x2={700} y2={225} stroke="#27ae60" strokeWidth="1.2" strokeDasharray="4,3" />
        <text x={650} y={218} textAnchor="middle" fontSize="9" fill="#27ae60">ΔP = ρgΔh</text>
        <text x={594} y={255} textAnchor="end" fontSize="9" fill="#27ae60">Δh</text>

        {/* P₀ intercept */}
        <circle cx={530} cy={275} r={4} fill="#c0392b" />
        <text x={535} y={290} fontSize="9" fill="#c0392b">P₀</text>

        {/* Formula */}
        <rect x={545} y={80} width={255} height={50} rx={4} fill="#fff" stroke="#c0392b" strokeWidth="1.2} " />
        <text x={672} y={102} textAnchor="middle" fontSize="12" fontWeight="700" fill="#1a1a2e" fontFamily="'Courier New',monospace">P = P₀ + ρgh</text>
        <text x={672} y={120} textAnchor="middle" fontSize="10" fill="#555">ρ = fluid density, g = 9.81 m/s²</text>
      </svg>
      <div style={S.dCaption}>
        Pressure in a static fluid increases linearly with depth: P = P₀ + ρgh. At any given depth, pressure is equal in all horizontal directions (isotropic). This is why dams are thicker at the base and why submarines have pressure hulls.
      </div>
    </div>
  );
}

// ── Diagram 8: Boyle's Law Applications ──────────────────────────
function DiagramApplications() {
  const W = 860, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Real-World Applications of Boyle's Law</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* ── Lungs ── */}
        <rect x={15} y={15} width={250} height={270} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={140} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#c0392b">Breathing (Lungs)</text>
        {/* Lung shape */}
        <ellipse cx={100} cy={155} rx={35} ry={55} fill="#ffcccc" stroke="#c0392b" strokeWidth="1.5" opacity="0.8" />
        <ellipse cx={180} cy={155} rx={35} ry={55} fill="#ffcccc" stroke="#c0392b" strokeWidth="1.5" opacity="0.8" />
        {/* Trachea */}
        <rect x={128} y={70} width={24} height={38} rx={4} fill="#888" stroke="#555" strokeWidth="1.5" />
        <text x={140} y={245} textAnchor="middle" fontSize="9" fill="#555">Inhale: diaphragm ↓</text>
        <text x={140} y={258} textAnchor="middle" fontSize="9" fill="#555">V↑ → P↓ → air flows in</text>
        <text x={140} y={271} textAnchor="middle" fontSize="9" fill="#c0392b" fontWeight="700">P₁V₁ = P₂V₂</text>

        {/* ── Syringe ── */}
        <rect x={285} y={15} width={255} height={270} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={412} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#2E75B6">Syringe / Pump</text>
        {/* Syringe barrel */}
        <rect x={310} y={100} width={155} height={50} rx={4} fill="#d6eaf8" stroke="#2E75B6" strokeWidth="2" />
        <rect x={465} y={112} width={30} height={26} rx={3} fill="#888" stroke="#444" strokeWidth="1.5" />
        {/* Plunger */}
        <rect x={315} y={108} width={70} height={34} fill="#2E75B6" opacity="0.2" stroke="none" />
        <rect x={310} y={104} width={20} height={42} rx={3} fill="#888" stroke="#444" strokeWidth="1.5" />
        <line x1={320} y1={104} x2={320} y2={60} stroke="#888" strokeWidth="3" />
        <rect x={300} y={50} width={40} height={16} rx={3} fill="#888" stroke="#444" strokeWidth="1.5" />
        {/* Arrows on plunger */}
        <line x1={320} y1={84} x2={320} y2={98} stroke="#c0392b" strokeWidth="2.5" />
        <polygon points="314,95 320,104 326,95" fill="#c0392b" />
        <text x={340} y={78} fontSize="9" fill="#c0392b">Push ↓</text>
        <text x={412} y={240} textAnchor="middle" fontSize="9" fill="#555">V↓ → P↑ → fluid expelled</text>
        <text x={412} y={253} textAnchor="middle" fontSize="9" fill="#555">Pull: V↑ → P↓ → fluid drawn in</text>
        <text x={412} y={266} textAnchor="middle" fontSize="9" fill="#2E75B6" fontWeight="700">Medical, bicycle pump, suction</text>

        {/* ── Deep sea diving ── */}
        <rect x={560} y={15} width={285} height={270} rx={8} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5" />
        <text x={702} y={36} textAnchor="middle" fontSize="11" fontWeight="700" fill="#27ae60">Scuba Diving</text>
        {/* Diver silhouette */}
        <ellipse cx={702} cy={95} rx={18} ry={22} fill="#888" opacity="0.7" />
        {/* Tank */}
        <rect x={715} y={78} width={18} height={40} rx={4} fill="#555" stroke="#333" strokeWidth="1.5" />
        <text x={738} y={100} fontSize="9" fill="#555">Tank</text>
        <text x={738} y={113} fontSize="9" fill="#555">150 atm</text>
        {/* Depth arrows */}
        <line x1={702} y1={125} x2={702} y2={185} stroke="#27ae60" strokeWidth="2.5" />
        <polygon points="696,182 702,192 708,182" fill="#27ae60" />
        <text x={716} y={158} fontSize="9" fill="#27ae60">Depth ↑</text>
        <text x={716} y={170} fontSize="9" fill="#27ae60">P ↑</text>
        {/* Bubble expansion */}
        {[5,8,12,16,20].map((r,i) => (
          <circle key={i} cx={648 + i * 10} cy={185 - i * 10} r={r} fill="none"
            stroke="#2E75B6" strokeWidth="1.5" opacity={0.8 - i * 0.12} />
        ))}
        <text x={600} y={232} fontSize="9" fill="#555">Air bubble rises:</text>
        <text x={600} y={245} fontSize="9" fill="#555">P↓ → V↑ (could cause</text>
        <text x={600} y={258} fontSize="9" fill="#c0392b" fontWeight="700">decompression sickness</text>
        <text x={600} y={271} fontSize="9" fill="#555">if ascent too fast)</text>
      </svg>
      <div style={S.dCaption}>
        Boyle's Law governs breathing (diaphragm changes lung volume to drive air flow), syringes and pumps (piston volume change creates pressure differential), and scuba diving (rising air bubbles expand as external pressure decreases — rapid ascent is dangerous).
      </div>
    </div>
  );
}

export default function BoyleLaw() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Boyle's Law and Fluid Dynamics</h1>

      <p style={S.p}>
        <strong>Boyle's Law</strong>, formulated by Robert Boyle in 1662, is one of the foundational laws of gas behaviour. It states that, for a fixed amount of gas at constant temperature, the pressure and volume are inversely proportional: if you halve the volume, you double the pressure, and vice versa. This relationship, expressed as <strong>PV = constant</strong>, was the first quantitative statement about the behaviour of gases and remains central to physics, chemistry, engineering, and medicine.
      </p>
      <p style={S.p}>
        Boyle's Law is a special case of the more general <strong>Ideal Gas Law</strong> (PV = nRT), and its physical origin lies in the <strong>kinetic theory of gases</strong>: molecules in a smaller volume collide with the container walls more frequently, producing a higher pressure. At constant temperature, molecular speeds are unchanged, so only the collision frequency — and therefore the pressure — responds to the volume change.
      </p>
      <p style={S.p}>
        This page places Boyle's Law in the broader context of <strong>fluid dynamics</strong> and the physics of pressure. It covers Pascal's Law (pressure transmission in fluids), hydrostatic pressure (pressure variation with depth), the behaviour of real gases, and the practical consequences of pressure–volume relationships in biological, medical, and engineering systems.
      </p>

      <InfoBox title="What This Page Covers" items={[
        "Boyle's Law: statement, equation, P-V graph and isotherms",
        "Kinetic theory explanation: molecular collisions and pressure",
        "The Ideal Gas Law and the other gas laws (Charles, Gay-Lussac)",
        "Combined Gas Law: P₁V₁/T₁ = P₂V₂/T₂",
        "Real gases: van der Waals equation, compressibility factor Z",
        "Pascal's Law: pressure transmission and hydraulic systems",
        "Hydrostatic pressure: P = P₀ + ρgh and pressure with depth",
        "Fluid statics: buoyancy, Archimedes' principle",
        "Fluid dynamics: Bernoulli's equation, continuity equation",
        "Applications: breathing, syringes, scuba diving, weather, engines",
        "Deviations from ideal behaviour and real-gas corrections",
      ]}/>

      <h2 style={S.h2}>Boyle's Law — Statement and Equation</h2>
      <p style={S.p}>
        Boyle's Law states that at constant temperature, the pressure of a given mass of gas is inversely proportional to its volume. Mathematically, P ∝ 1/V (constant T, n), or equivalently <strong>PV = k</strong> where k is a constant that depends on the amount of gas and the temperature. This means that any two states of the same gas at the same temperature satisfy <strong>P₁V₁ = P₂V₂</strong>.
      </p>
      <DiagramPistons/>
      <Table2 rows={[
        ["Boyle's Law statement","At constant temperature and amount (n), P ∝ 1/V\nEquivalently: PV = constant = nRT"],
        ["Mathematical form","P₁V₁ = P₂V₂  (at constant T and n)\nRearranges to: P₂ = P₁V₁/V₂  or  V₂ = P₁V₁/P₂"],
        ["Conditions of validity","Temperature must be constant (isothermal process)\nGas must be ideal (no intermolecular forces, negligible molecular volume)\nAmount of gas n is fixed (closed system)"],
        ["Units of pressure","Pascal (Pa = N/m²) — SI unit\nAlso: atm, bar, mmHg (torr), psi\n1 atm = 101,325 Pa = 1.01325 bar = 760 mmHg"],
        ["Units of volume","m³ (SI); also litres (L), cm³, mL\n1 m³ = 1000 L = 10⁶ cm³"],
        ["Worked example","Gas at P₁ = 2 atm, V₁ = 3 L is expanded to V₂ = 6 L at constant T\nP₂ = P₁V₁/V₂ = (2 × 3)/6 = 1 atm\nPressure halved when volume doubled ✓"],
        ["Historical context","Robert Boyle (1662): first gas law; used J-shaped tube with mercury column\nRichard Towneley and Henry Power: earlier experimental data\nEdme Mariotte: rediscovered independently in France (1676)"],
      ]}/>

      <h2 style={S.h2}>P–V Graph and Isotherms</h2>
      <p style={S.p}>
        On a pressure–volume graph, Boyle's Law appears as a <strong>rectangular hyperbola</strong> (PV = constant). Each isotherm (curve of constant temperature) is a separate hyperbola. Increasing the temperature shifts the curve outward because k = nRT is larger. The area under any isotherm (integral of P dV) gives the work done by or on the gas during the process.
      </p>
      <DiagramPVGraph/>
      <Table2 rows={[
        ["Shape of P-V curve","Rectangular hyperbola: P = k/V\nProduct PV = k at every point on the curve"],
        ["Isotherms","Each curve corresponds to a fixed temperature T\nHigher T → higher k = nRT → hyperbola further from origin"],
        ["Work done in isothermal expansion","W = nRT ln(V₂/V₁) = nRT ln(P₁/P₂)\nArea under P-V curve; positive when gas expands (does work on surroundings)"],
        ["Area under curve","For compression (V decreases): W is negative (work done on gas)\nFor expansion: W positive (gas does work)"],
        ["Isothermal vs adiabatic","Isothermal: T constant, heat exchanged with surroundings; PV = const\nAdiabatic: no heat exchange; PV^γ = const  (γ = Cₚ/Cᵥ > 1)\nAdiabatic curve steeper than isothermal"],
        ["Internal energy","Isothermal process for ideal gas: ΔU = 0 (U depends only on T)\nFirst Law: Q = W (heat added equals work done by gas)"],
        ["Slope of isotherm","dP/dV = −P/V  (hyperbola slope)\nSteeper at small V (high P) — large pressure change for small volume change"],
      ]}/>

      <h2 style={S.h2}>Kinetic Theory — Molecular Explanation</h2>
      <DiagramKineticTheory/>
      <Table2 rows={[
        ["Kinetic theory of gases","Gas consists of point particles in random motion\nNo intermolecular forces; elastic collisions; molecular volume negligible"],
        ["Pressure origin","Pressure = force per unit area = rate of momentum transfer to walls\nP = (1/3)ρ⟨v²⟩  or  P = (2/3)(N/V)(½m⟨v²⟩)"],
        ["Boyle's Law from kinetic theory","At constant T: ½m⟨v²⟩ = constant (fixed average KE)\nP = (N/V) × (2/3) × average KE  → P ∝ 1/V for fixed N, T ✓"],
        ["RMS speed","v_rms = √(3RT/M)  (M = molar mass in kg/mol)\nAt 300 K: N₂ v_rms ≈ 517 m/s; H₂ v_rms ≈ 1934 m/s"],
        ["Maxwell-Boltzmann distribution","Distribution of molecular speeds; most probable speed v_p = √(2RT/M)\nAverage speed ⟨v⟩ = √(8RT/πM);  v_p < ⟨v⟩ < v_rms"],
        ["Mean free path","λ = 1/(√2 π d² n)  (d = molecular diameter, n = number density)\nAt STP: λ_air ≈ 68 nm; decreasing V increases n → decreases λ"],
        ["Collision frequency","z = √2 π d² ⟨v⟩ n  (collisions per second per molecule)\nAs V decreases: n increases → z increases → P increases"],
        ["Degrees of freedom","Monatomic: 3 translational; Cᵥ = (3/2)R\nDiatomic: 3 translational + 2 rotational; Cᵥ = (5/2)R at room T\nAffects adiabatic index γ and sound speed in gas"],
      ]}/>

      <h2 style={S.h2}>The Gas Laws — Boyle's in Context</h2>
      <DiagramCombinedGasLaw/>
      <Table2 rows={[
        ["Ideal Gas Law","PV = nRT\nn = moles of gas, R = 8.314 J mol⁻¹ K⁻¹, T in Kelvin\nContains all three classical gas laws as special cases"],
        ["Boyle's Law (T, n const)","PV = nRT = constant  →  P₁V₁ = P₂V₂"],
        ["Charles's Law (P, n const)","V/T = nR/P = constant  →  V₁/T₁ = V₂/T₂\nV ∝ T at constant P; absolute zero T = 0 K → V = 0 (extrapolated)"],
        ["Gay-Lussac's Law (V, n const)","P/T = nR/V = constant  →  P₁/T₁ = P₂/T₂\nP ∝ T at constant V; basis of constant-volume thermometry"],
        ["Combined Gas Law","P₁V₁/T₁ = P₂V₂/T₂  (n constant)\nAllows all three variables to change; reduces to each law when one is fixed"],
        ["Avogadro's Law (P, T const)","V/n = RT/P = constant  →  equal volumes at same T and P contain equal molecules\nMolar volume at STP (0°C, 1 atm) = 22.4 L/mol"],
        ["Standard conditions","STP: T = 273.15 K (0°C), P = 101.325 kPa; Vm = 22.414 L/mol\nSATP: T = 298.15 K (25°C), P = 100 kPa; Vm = 24.789 L/mol"],
        ["Gas constant R","R = 8.314 J mol⁻¹ K⁻¹ = 8.314 Pa·m³ mol⁻¹ K⁻¹\nAlso: R = Nₐ × kB  (Nₐ = 6.022×10²³, kB = 1.381×10⁻²³ J/K)"],
      ]}/>

      <h2 style={S.h2}>Real Gases and the Van der Waals Equation</h2>
      <DiagramRealVsIdeal/>
      <Table2 rows={[
        ["Ideal gas assumptions","Point particles (no volume); no intermolecular forces; elastic collisions\nBreaks down at high P and low T (near condensation)"],
        ["Compressibility factor Z","Z = PV/(nRT)\nIdeal: Z = 1; Z < 1: attractions dominate; Z > 1: repulsions dominate"],
        ["Van der Waals equation","(P + an²/V²)(V − nb) = nRT\na = attraction correction (Pa·m⁶/mol²); b = volume correction (m³/mol)"],
        ["Correction terms","an²/V²: accounts for intermolecular attractions reducing effective P\nnb: excluded volume — actual space available is less than V"],
        ["Van der Waals constants","CO₂: a = 3.64, b = 0.0427 L/mol (highly non-ideal)\nH₂:  a = 0.244, b = 0.0266 (close to ideal at room T)\nHe:  a = 0.0341, b = 0.0238 (most ideal real gas)"],
        ["Boyle temperature","Temperature at which a real gas behaves most like ideal gas at moderate P\nT_B = a/(Rb); for N₂: T_B ≈ 327 K; CO₂: T_B ≈ 710 K"],
        ["Critical point","Above T_c and P_c: single supercritical phase (no liquid-gas distinction)\nCO₂: T_c = 304 K, P_c = 72.8 atm — used in supercritical extraction"],
        ["Virial equation","Z = 1 + B(T)/V + C(T)/V² + ...  (B, C = virial coefficients)\nMore rigorous power series; B(T) changes sign at Boyle temperature"],
      ]}/>

      <h2 style={S.h2}>Pascal's Law and Hydraulic Systems</h2>
      <DiagramPascal/>
      <Table2 rows={[
        ["Pascal's Law","Pressure applied to an enclosed static fluid is transmitted undiminished\nin all directions throughout the fluid\nP = F/A at every point at the same height"],
        ["Hydraulic advantage","F₂ = F₁ × (A₂/A₁)\nSmall force on small piston → large force on large piston\nWork conserved: F₁d₁ = F₂d₂  (large piston moves less distance)"],
        ["Hydraulic jack","Input: small force, small piston; output: large force, large piston\nUsed to lift cars, aircraft, industrial presses; load capacity up to 1000 tonnes"],
        ["Hydraulic brakes","Foot pedal applies pressure to brake fluid; transmitted to all four callipers\nEqual braking force at each wheel regardless of pipe length"],
        ["Hydraulic press","Used in metal forming, coin minting, baling (paper, recycling)\nPressure up to 700 MPa possible with hydraulic multiplier circuits"],
        ["Hydrostatic paradox","Pressure at a given depth depends only on depth, not on shape of container\nA narrow tall container has same pressure at base as a wide one of equal height"],
        ["Pressure in SI","1 Pa = 1 N/m²;  1 bar = 10⁵ Pa;  1 atm = 101,325 Pa\n1 MPa = 10 bar ≈ 145 psi;  blood pressure ~120/80 mmHg ≈ 16/11 kPa"],
      ]}/>

      <h2 style={S.h2}>Hydrostatic Pressure — Pressure with Depth</h2>
      <DiagramHydrostaticPressure/>
      <Table2 rows={[
        ["Hydrostatic pressure","P = P₀ + ρgh\nP₀ = surface pressure, ρ = fluid density (kg/m³), g = 9.81 m/s², h = depth (m)"],
        ["Every 10 m of water","ρgh = 1000 × 9.81 × 10 ≈ 98,100 Pa ≈ 1 atm\nAt 10 m depth: total P ≈ 2 atm; at 100 m: ≈ 11 atm"],
        ["Derivation","Consider thin horizontal slice of fluid thickness dh at depth h\nWeight of slice = ρg·A·dh; this rests on area A → dP = ρg dh\nIntegrate: P = P₀ + ρgh"],
        ["Pressure is isotropic","At any point in a static fluid, pressure is equal in all directions\nProved by considering forces on an infinitesimal tetrahedron"],
        ["Dams and water towers","Dam wall must be thicker at base (higher P) than at top\nWater tower: height h gives mains pressure ρgh (no pump needed for distribution)"],
        ["Atmospheric pressure","ρ of air decreases with altitude → P = P₀ exp(−Mgh/RT) (barometric formula)\nHalves every ~5500 m; at 10 km: ~0.26 atm"],
        ["Communicating vessels","Connected containers reach same level regardless of shape\nBasis of spirit levels, hydraulic surveying, U-tube manometers"],
        ["Pressure gauges","Absolute pressure: measured above vacuum (zero)\nGauge pressure: measured above atmospheric; P_abs = P_gauge + P_atm"],
      ]}/>

      <h2 style={S.h2}>Archimedes' Principle and Buoyancy</h2>
         A submerged or floating body has a buoyancy force facing upward equal to the weight of the fluid displaced by the body.
                         Since a floating body is in equilibrium, the floating body displaces a weight of fluid equal to its own weight. 
                         <br />
                        <br /> 
The center of buoyancy is located at the 3 dimensional center (centroid) of the displaced fluid. In the special case of a body existing at the 
interface of two fluids, the buoyant force is equal to the sum of the weights of the displaced fluids.
      <div style={{ textAlign: "center" }}>
  <img src={BuoyancyImg} alt="BuoyancyImg" width="65%"/>
</div>
    
      <Table2 rows={[
        ["Archimedes' Principle","Buoyant force on an object = weight of fluid displaced\nF_b = ρ_fluid × V_submerged × g"],
        ["Floating condition","Object floats when buoyant force = weight\nρ_object × V_total × g = ρ_fluid × V_submerged × g\nFraction submerged = ρ_object/ρ_fluid"],
        ["Sinking condition","ρ_object > ρ_fluid → object sinks (net downward force)\nSteel (ρ≈7800 kg/m³) sinks in water (ρ=1000 kg/m³)"],
        ["Apparent weight","W_apparent = W_actual − F_b\nObject appears lighter when submerged; used to measure density"],
        ["Ships and submarines","Steel ship floats because hull encloses air → average density < water\nSubmarine: ballast tanks fill/empty with water to adjust average density"],
        ["Hot air balloon","Air in balloon heated → density decreases → buoyancy exceeds weight\nLift = (ρ_cold − ρ_hot) × V × g"],
        ["Centre of buoyancy","Point through which buoyant force acts (centroid of displaced volume)\nStability: centre of buoyancy must be above centre of gravity for stable floating"],
      ]}/>

      <h2 style={S.h2}>Fluid Dynamics — Bernoulli's Equation</h2>
      <Table2 rows={[
        ["Continuity equation","A₁v₁ = A₂v₂  (incompressible fluid, steady flow)\nFlow rate Q = Av = constant; narrower pipe → faster flow"],
        ["Bernoulli's equation","P + ½ρv² + ρgh = constant  (along a streamline)\nConservation of energy per unit volume in steady, incompressible, non-viscous flow"],
        ["Bernoulli — pressure/velocity","P increases when v decreases and vice versa\nFast-moving fluid exerts less static pressure (e.g. aircraft wing lift, Venturi effect)"],
        ["Venturi effect","Fluid speeds up in a constriction → pressure drops\nUsed in carburettors, Venturi meters, atomisers, aerofoils"],
        ["Torricelli's theorem","Speed of fluid emerging from a hole at depth h: v = √(2gh)\nSpecial case of Bernoulli (P = P_atm at both surfaces and exit)"],
        ["Viscosity and Poiseuille flow","Real fluids have viscosity η (Pa·s); flow resisted by friction\nPoiseuille: Q = πr⁴ΔP/(8ηL)  — flow ∝ r⁴ (halving radius reduces flow 16×)"],
        ["Reynolds number","Re = ρvL/η  (dimensionless)\nRe < 2300: laminar flow; Re > 4000: turbulent flow; transition region in between"],
        ["Stokes' drag","F_drag = 6πηrv  (sphere of radius r, speed v, viscosity η)\nUsed in Millikan oil drop experiment; settling of particles in fluids"],
      ]}/>

      <h2 style={S.h2}>Applications of Boyle's Law</h2>
      <DiagramApplications/>
      <Table2 rows={[
        ["Breathing / respiration","Diaphragm contracts → thoracic volume increases → lung pressure below atmospheric\nAir flows in (inspiration); diaphragm relaxes → V decreases → P increases → air expelled"],
        ["Bicycle / tyre pump","Piston compresses air in barrel: V↓ → P increases above tyre pressure → valve opens\nBoyle's Law determines pressure ratio for any stroke length"],
        ["Scuba diving","Air tank ~150–200 atm; regulator reduces to ambient pressure at depth\nAscending: ambient P decreases → dissolved gas expands; must ascend slowly (decompression)"],
        ["Decompression sickness","Nitrogen dissolves in blood at high P (Henry's Law); if P drops too fast, bubbles form\nBoyle's Law: V_bubble = V_initial × P_deep / P_shallow — bubbles can block blood vessels"],
        ["Weather / meteorology","Rising air parcel expands (lower P aloft) → cools adiabatically → clouds/rain\nLapse rate: temperature decreases ~9.8°C/km for dry air (adiabatic)"],
        ["Internal combustion engine","Compression stroke: piston reduces V → P and T rise → fuel ignites\nPower stroke: combustion gases expand → P drops, piston pushed down"],
        ["Sphygmomanometer (blood pressure)","Cuff inflated to collapse artery (stop flow); released slowly\nBoyle's Law governs air release; Korotkoff sounds heard at systolic and diastolic"],
        ["Altimeter","P decreases with altitude (barometric formula); measures P to infer altitude\nBoyle-type relationship used to calibrate aneroid capsule compression"],
        ["Medical ventilators","Positive pressure ventilation: forces air into lungs when patient cannot breathe\nPressure and tidal volume controlled via Boyle's Law relationships"],
        ["Champagne cork","Dissolved CO₂ under ~6 atm in bottle; on opening, P → 1 atm\nCO₂ expands ~6× → rapid bubble nucleation and effervescence"],
      ]}/>

      <InfoBox title="Key Formulae — Boyle's Law and Fluid Dynamics" items={[
        "Boyle's Law:  PV = constant  (at constant T, n)  →  P₁V₁ = P₂V₂",
        "Ideal Gas Law:  PV = nRT   (R = 8.314 J mol⁻¹ K⁻¹, T in Kelvin)",
        "Combined Gas Law:  P₁V₁/T₁ = P₂V₂/T₂   (n constant)",
        "Charles's Law:  V₁/T₁ = V₂/T₂   (P, n constant)",
        "Gay-Lussac's Law:  P₁/T₁ = P₂/T₂   (V, n constant)",
        "Van der Waals:  (P + an²/V²)(V − nb) = nRT",
        "Compressibility factor:  Z = PV/(nRT)   (ideal: Z = 1)",
        "Work in isothermal expansion:  W = nRT ln(V₂/V₁)",
        "Hydrostatic pressure:  P = P₀ + ρgh",
        "Pascal's Law:  P = F₁/A₁ = F₂/A₂   →   F₂ = F₁(A₂/A₁)",
        "Archimedes' buoyancy:  F_b = ρ_fluid × V_displaced × g",
        "Continuity (incompressible):  A₁v₁ = A₂v₂",
        "Bernoulli's equation:  P + ½ρv² + ρgh = constant",
        "Poiseuille flow:  Q = πr⁴ΔP / (8ηL)",
        "Reynolds number:  Re = ρvL/η   (Re < 2300: laminar; > 4000: turbulent)",
      ]}/>
    </div>
  );
}